<template>
  <div class="u-containar-md registerForm">
    <HeadingLv2 text="パスワードを忘れた方" simple />
      <section>
        <div class="text_area">
          <TextBlock>
            <ul class="notes">
              <li>
                入力いただいたメールアドレスに、再設定のためのメールをお送りいたしました。メールに記載されたURLにアクセスし、パスワードを再設定してください。
              </li>
            </ul>
          </TextBlock>
        </div>
      </section>

      <section>
        <div class="btn">
          <Button
            href="/"
            label="トップページ"
            :handleClick="
              () => {
                $router.push('/')
              }
            "
            primary
          />
        </div>
      </section>
  </div>
</template>

<script lang="ts">
import smoothscroll from 'smoothscroll-polyfill'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import { onMounted, computed, SetupContext, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { applyValidation } from '@/utils/validation'
import axios from 'axios'

export default {
  name: 'RegistProfile',
  setup(props: any) {
    const store = useStore()
    const router = useRouter()

    console.log('store', store.state)
    if (store.state.isPasswordToken != true) {
      router.push('/');
    }

    store.commit('setPasswordToken', false);

  },
  components: {
    HeadingLv2,
    Button,
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.text_area{
  margin-bottom: 15px;
}

</style>
